interface ConnectionJson {
  blockedBy?: string;
  expiredAt?: string;
  conversationId?: string;
  status?: string;
  startedBy?: string;
}

export enum ConnectionTypes {
  NOT_ESTABLISHED = 'not_established',
  REQUEST_SENT = 'request_sent',
  REQUEST_RECEIVED = 'request_received',
  ESTABLISHED = 'established',
  BLOCKED = 'blocked',
  MY_SELF = 'my_self',
  EXPIRED = 'expired'
}

interface ConnectionInterface {
  type: ConnectionTypes;
  blockedByMe?: boolean | null;
  conversationId?: string | null;
}

export class Connection implements ConnectionInterface {
  type: ConnectionTypes;
  blockedByMe?: boolean | null;
  conversationId?: string | null;

  constructor(data: ConnectionInterface) {
    this.type = data.type;
    this.blockedByMe = data.blockedByMe ?? null;
    this.conversationId = data.conversationId ?? null;
  }
}

export const createConnectionFromJson = (json: ConnectionJson, params: { currentUserId: string; userId: string }) : Connection => {
  const { currentUserId, userId } = params;

    if (currentUserId === userId) {
      return new Connection({
        type: ConnectionTypes.MY_SELF
      });
    }

    if (json.blockedBy) {
      return new Connection({
        type: ConnectionTypes.BLOCKED,
        blockedByMe: json.blockedBy === currentUserId
      });
    }

    if (json.expiredAt) {
      return new Connection({
        type: ConnectionTypes.EXPIRED
      });
    }

    if (json.conversationId) {
      switch (json.status) {
        case 'established':
          return new Connection({
            type: ConnectionTypes.ESTABLISHED,
            conversationId: json.conversationId
          });
        case 'pending':
          if (currentUserId === json.startedBy) {
            return new Connection({
              type: ConnectionTypes.REQUEST_SENT
            });
          } else {
            return new Connection({
              type: ConnectionTypes.REQUEST_RECEIVED,
              conversationId: json.conversationId
            });
          }
        default:
          return new Connection({
            type: ConnectionTypes.NOT_ESTABLISHED
          });
      }
    }

    return new Connection({
      type: ConnectionTypes.NOT_ESTABLISHED
    });
}
